import apiClient from "./apiClient";

export const fetchPublicTeamMembers = async () => {
  const { data } = await apiClient.get("/public/team-members");
  return data.data;
};

export const fetchPublicPortfolioItems = async (categoryId) => {
  const { data } = await apiClient.get("/public/portfolio-items", {
    params: { category_id: categoryId || undefined },
  });
  return data.data;
};

export const fetchPublicPortfolioCategories = async () => {
  const { data } = await apiClient.get("/public/portfolio-categories");
  return data.data;
};
